import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0ffccd92 = () => interopDefault(import('..\\pages\\400.vue' /* webpackChunkName: "pages/400" */))
const _3f3c6f60 = () => interopDefault(import('..\\pages\\activatesmartalerts.vue' /* webpackChunkName: "pages/activatesmartalerts" */))
const _821d2910 = () => interopDefault(import('..\\pages\\articles\\index.vue' /* webpackChunkName: "pages/articles/index" */))
const _05ac06d3 = () => interopDefault(import('..\\pages\\calculator\\index.vue' /* webpackChunkName: "pages/calculator/index" */))
const _312c1779 = () => interopDefault(import('..\\pages\\categories\\index.vue' /* webpackChunkName: "pages/categories/index" */))
const _523cc3a6 = () => interopDefault(import('..\\pages\\cc.vue' /* webpackChunkName: "pages/cc" */))
const _2f4e66b8 = () => interopDefault(import('..\\pages\\companies\\index.vue' /* webpackChunkName: "pages/companies/index" */))
const _04c4f202 = () => interopDefault(import('..\\pages\\company\\index.vue' /* webpackChunkName: "pages/company/index" */))
const _a046b03e = () => interopDefault(import('..\\pages\\contactus\\index.vue' /* webpackChunkName: "pages/contactus/index" */))
const _d285cbf2 = () => interopDefault(import('..\\pages\\enter\\index.vue' /* webpackChunkName: "pages/enter/index" */))
const _3914e94b = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _449c6712 = () => interopDefault(import('..\\pages\\feedback.vue' /* webpackChunkName: "pages/feedback" */))
const _64721174 = () => interopDefault(import('..\\pages\\help\\index.vue' /* webpackChunkName: "pages/help/index" */))
const _9e6d1582 = () => interopDefault(import('..\\pages\\jobs\\index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _4307824f = () => interopDefault(import('..\\pages\\myjobs.vue' /* webpackChunkName: "pages/myjobs" */))
const _09008795 = () => interopDefault(import('..\\pages\\personal\\index.vue' /* webpackChunkName: "pages/personal/index" */))
const _bbe128d6 = () => interopDefault(import('..\\pages\\resetPassword\\index.vue' /* webpackChunkName: "pages/resetPassword/index" */))
const _d97e13dc = () => interopDefault(import('..\\pages\\sendcvsummaryremove.vue' /* webpackChunkName: "pages/sendcvsummaryremove" */))
const _36f0beb7 = () => interopDefault(import('..\\pages\\services\\index.vue' /* webpackChunkName: "pages/services/index" */))
const _2612a26c = () => interopDefault(import('..\\pages\\sitemap\\index.vue' /* webpackChunkName: "pages/sitemap/index" */))
const _c4436b02 = () => interopDefault(import('..\\pages\\smartalerts\\index.vue' /* webpackChunkName: "pages/smartalerts/index" */))
const _4b878232 = () => interopDefault(import('..\\pages\\smartalertsremove.vue' /* webpackChunkName: "pages/smartalertsremove" */))
const _29a44954 = () => interopDefault(import('..\\pages\\unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _b4db911c = () => interopDefault(import('..\\pages\\דרושים-הייטק\\index.vue' /* webpackChunkName: "pages/דרושים-הייטק/index" */))
const _360a15e6 = () => interopDefault(import('..\\pages\\מדד-תעסוקה\\index.vue' /* webpackChunkName: "pages/מדד-תעסוקה/index" */))
const _717af9de = () => interopDefault(import('..\\pages\\קורות-חיים\\index.vue' /* webpackChunkName: "pages/קורות-חיים/index" */))
const _488555f8 = () => interopDefault(import('..\\pages\\companies\\voice.vue' /* webpackChunkName: "pages/companies/voice" */))
const _ca813632 = () => interopDefault(import('..\\pages\\personal\\cvfiles.vue' /* webpackChunkName: "pages/personal/cvfiles" */))
const _624e18d2 = () => interopDefault(import('..\\pages\\personal\\history.vue' /* webpackChunkName: "pages/personal/history" */))
const _363718bd = () => interopDefault(import('..\\pages\\personal\\myboard.vue' /* webpackChunkName: "pages/personal/myboard" */))
const _d693ad4e = () => interopDefault(import('..\\pages\\personal\\removedJobs.vue' /* webpackChunkName: "pages/personal/removedJobs" */))
const _3fce7923 = () => interopDefault(import('..\\pages\\personal\\smartalerts.vue' /* webpackChunkName: "pages/personal/smartalerts" */))
const _c53fc7e4 = () => interopDefault(import('..\\pages\\personal\\smartalertsnotification.vue' /* webpackChunkName: "pages/personal/smartalertsnotification" */))
const _ea333b82 = () => interopDefault(import('..\\pages\\article\\_code\\index.vue' /* webpackChunkName: "pages/article/_code/index" */))
const _39589a01 = () => interopDefault(import('..\\pages\\articles\\_cat\\index.vue' /* webpackChunkName: "pages/articles/_cat/index" */))
const _1ab20ca9 = () => interopDefault(import('..\\pages\\קורות-חיים\\_id\\index.vue' /* webpackChunkName: "pages/קורות-חיים/_id/index" */))
const _78898f01 = () => interopDefault(import('..\\pages\\job\\_code\\_hash\\index.vue' /* webpackChunkName: "pages/job/_code/_hash/index" */))
const _156269d6 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _0b7ade03 = () => interopDefault(import('~/pages/jobs/index.vue' /* webpackChunkName: "" */))
const _66a05238 = () => interopDefault(import('~/pages/company/' /* webpackChunkName: "" */))
const _dcaf4720 = () => interopDefault(import('~/pages/דרושים-הייטק/index.vue' /* webpackChunkName: "" */))
const _1e9e1a6e = () => interopDefault(import('~/pages/categories/index.vue' /* webpackChunkName: "" */))
const _53041b26 = () => interopDefault(import('~/pages/personal/index.vue' /* webpackChunkName: "" */))
const _5a2a932e = () => interopDefault(import('~/pages/smartalerts/index.vue' /* webpackChunkName: "" */))
const _17ecd8e3 = () => interopDefault(import('~/pages/personal/smartalerts' /* webpackChunkName: "" */))
const _5bb5817d = () => interopDefault(import('~/pages/personal/myboard' /* webpackChunkName: "" */))
const _0c711419 = () => interopDefault(import('~/pages/personal/removedJobs' /* webpackChunkName: "" */))
const _45ce72a7 = () => interopDefault(import('~/pages/personal/cvfiles' /* webpackChunkName: "" */))
const _38dad957 = () => interopDefault(import('~/pages/personal/history' /* webpackChunkName: "" */))
const _f7cb17d8 = () => interopDefault(import('~/pages/myjobs' /* webpackChunkName: "" */))
const _dcf417be = () => interopDefault(import('~/pages/enter/index.vue' /* webpackChunkName: "" */))
const _5db36064 = () => interopDefault(import('~/pages/companies/index.vue' /* webpackChunkName: "" */))
const _3ad8a987 = () => interopDefault(import('~/pages/contactus/index.vue' /* webpackChunkName: "" */))
const _6b28b02f = () => interopDefault(import('~/pages/calculator/index.vue' /* webpackChunkName: "" */))
const _1ed2b431 = () => interopDefault(import('~/pages/קורות-חיים/index.vue' /* webpackChunkName: "" */))
const _f63931a4 = () => interopDefault(import('~/pages/help/index.vue' /* webpackChunkName: "" */))
const _2563ddd0 = () => interopDefault(import('~/pages/index.vue' /* webpackChunkName: "" */))
const _3fb5c5d3 = () => interopDefault(import('~/pages/resetPassword/index.vue' /* webpackChunkName: "" */))
const _8236c25c = () => interopDefault(import('~/pages/smartalertsremove' /* webpackChunkName: "" */))
const _42a493f0 = () => interopDefault(import('~/pages/services' /* webpackChunkName: "" */))
const _7949c117 = () => interopDefault(import('~/pages/unsubscribe.vue' /* webpackChunkName: "" */))
const _2d9ffad5 = () => interopDefault(import('~/pages/sendcvsummaryremove.vue' /* webpackChunkName: "" */))
const _7ac0cd13 = () => interopDefault(import('~/pages/activatesmartalerts.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/400",
    component: _0ffccd92,
    name: "400"
  }, {
    path: "/activatesmartalerts",
    component: _3f3c6f60,
    name: "activatesmartalerts"
  }, {
    path: "/articles",
    component: _821d2910,
    name: "articles"
  }, {
    path: "/calculator",
    component: _05ac06d3,
    name: "calculator"
  }, {
    path: "/categories",
    component: _312c1779,
    name: "categories"
  }, {
    path: "/cc",
    component: _523cc3a6,
    name: "cc"
  }, {
    path: "/companies",
    component: _2f4e66b8,
    name: "companies"
  }, {
    path: "/company",
    component: _04c4f202,
    name: "company"
  }, {
    path: "/contactus",
    component: _a046b03e,
    name: "contactus"
  }, {
    path: "/enter",
    component: _d285cbf2,
    name: "enter"
  }, {
    path: "/error",
    component: _3914e94b,
    name: "error"
  }, {
    path: "/feedback",
    component: _449c6712,
    name: "feedback"
  }, {
    path: "/help",
    component: _64721174,
    name: "help"
  }, {
    path: "/jobs",
    component: _9e6d1582,
    name: "jobs"
  }, {
    path: "/myjobs",
    component: _4307824f,
    name: "myjobs"
  }, {
    path: "/personal",
    component: _09008795,
    name: "personal"
  }, {
    path: "/resetPassword",
    component: _bbe128d6,
    name: "resetPassword"
  }, {
    path: "/sendcvsummaryremove",
    component: _d97e13dc,
    name: "sendcvsummaryremove"
  }, {
    path: "/services",
    component: _36f0beb7,
    name: "services"
  }, {
    path: "/sitemap",
    component: _2612a26c,
    name: "sitemap"
  }, {
    path: "/smartalerts",
    component: _c4436b02,
    name: "smartalerts"
  }, {
    path: "/smartalertsremove",
    component: _4b878232,
    name: "smartalertsremove"
  }, {
    path: "/unsubscribe",
    component: _29a44954,
    name: "unsubscribe"
  }, {
    path: "/דרושים-הייטק",
    component: _b4db911c,
    name: "דרושים-הייטק"
  }, {
    path: "/מדד-תעסוקה",
    component: _360a15e6,
    name: "מדד-תעסוקה"
  }, {
    path: "/קורות-חיים",
    component: _717af9de,
    name: "קורות-חיים"
  }, {
    path: "/companies/voice",
    component: _488555f8,
    name: "companies-voice"
  }, {
    path: "/personal/cvfiles",
    component: _ca813632,
    name: "personal-cvfiles"
  }, {
    path: "/personal/history",
    component: _624e18d2,
    name: "personal-history"
  }, {
    path: "/personal/myboard",
    component: _363718bd,
    name: "personal-myboard"
  }, {
    path: "/personal/removedJobs",
    component: _d693ad4e,
    name: "personal-removedJobs"
  }, {
    path: "/personal/smartalerts",
    component: _3fce7923,
    name: "personal-smartalerts"
  }, {
    path: "/personal/smartalertsnotification",
    component: _c53fc7e4,
    name: "personal-smartalertsnotification"
  }, {
    path: "/article/:code?",
    component: _ea333b82,
    name: "article-code"
  }, {
    path: "/articles/:cat",
    component: _39589a01,
    name: "articles-cat"
  }, {
    path: "/קורות-חיים/:id?",
    component: _1ab20ca9,
    name: "קורות-חיים-id"
  }, {
    path: "/job/:code?/:hash?",
    component: _78898f01,
    name: "job-code-hash"
  }, {
    path: "/",
    component: _156269d6,
    name: "index"
  }, {
    path: "/עבודה-מיידית-בזמן-קורונה/",
    component: _0b7ade03,
    alias: "/jobs?isCorona=1",
    name: "corona-page"
  }, {
    path: "/משרות-ללא-קורות-חיים/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    alias: "/jobs?cv=1",
    name: "no-cv-jobs-page"
  }, {
    path: "/%D7%93%D7%A8%D7%95%D7%A9%D7%99%D7%9D-*",
    component: _66a05238,
    name: "company-page-client"
  }, {
    path: "/דרושים-(\\d+)-*",
    component: _66a05238,
    name: "company-page-server"
  }, {
    path: "/drushimhitech.aspx",
    component: _dcaf4720,
    name: "drushimhitech"
  }, {
    path: "/categories.aspx",
    component: _1e9e1a6e,
    name: "categories2"
  }, {
    path: "/jobs/area/:area/",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/area/:area/",
    name: "jobs1"
  }, {
    path: "/משרות-ללא-קורות-חיים/area/:area/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page1"
  }, {
    path: "/jobs/search/:search+",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/search/:search/",
    name: "jobs-search"
  }, {
    path: "/משרות-ללא-קורות-חיים/search/:search+",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page2"
  }, {
    path: "/jobs/subcat/:subcat/",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/subcat/:subcat/",
    name: "jobs2"
  }, {
    path: "/משרות-ללא-קורות-חיים/subcat/:subcat/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page3"
  }, {
    path: "/jobs/:cat/",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/:cat/",
    name: "jobscat"
  }, {
    path: "/משרות-ללא-קורות-חיים/:cat/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page4"
  }, {
    path: "/jobs/:cat/area/:area/",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/:cat/area/:area/",
    name: "jobs4"
  }, {
    path: "/משרות-ללא-קורות-חיים/:cat/area/:area/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page5"
  }, {
    path: "/jobs/subcat/:subcat/area/:area",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/subcat/:subcat/area/:area",
    name: "jobs5"
  }, {
    path: "/משרות-ללא-קורות-חיים/subcat/:subcat/area/:area",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page6"
  }, {
    path: "/jobs/?",
    component: _0b7ade03,
    name: "jobs8"
  }, {
    path: "/jobs/:cat/subcat/:subcat",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/:cat/subcat/:subcat",
    name: "jobs9"
  }, {
    path: "/משרות-ללא-קורות-חיים/:cat/subcat/:subcat",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page7"
  }, {
    path: "/jobs/:cat/subcat/:subcat/area/:area/",
    component: _0b7ade03,
    alias: "/עבודה-מיידית-בזמן-קורונה/:cat/subcat/:subcat/area/:area/",
    name: "jobs10"
  }, {
    path: "/משרות-ללא-קורות-חיים/:cat/subcat/:subcat/area/:area/",
    component: _0b7ade03,
    props: {"isNoCvPage":true},
    name: "no-cv-jobs-page8"
  }, {
    path: "/personal/",
    component: _53041b26,
    name: "candidatesMain"
  }, {
    path: "/smartalerts.aspx",
    component: _5a2a932e,
    alias: "/סוכן-חכם/",
    name: "smartagent"
  }, {
    path: "/personal/smartalerts.aspx",
    component: _17ecd8e3,
    name: "smartalertsaspx"
  }, {
    path: "/personal/myboard.aspx",
    component: _5bb5817d,
    name: "candidatesBoard"
  }, {
    path: "/personal/removedjobs.aspx",
    component: _0c711419,
    name: "removedJobs"
  }, {
    path: "/personal/cvfiles.aspx",
    component: _45ce72a7,
    name: "candidatesCvfiles"
  }, {
    path: "/personal/history.aspx",
    component: _38dad957,
    name: "candidatesHistory"
  }, {
    path: "/myjobs.aspx",
    component: _f7cb17d8,
    name: "candidatesMyjobs"
  }, {
    path: "/enter.aspx",
    component: _dcf417be,
    alias: "/enter/:id",
    name: "seekerlogin"
  }, {
    path: "/companies.aspx",
    component: _5db36064,
    name: "companiesLobby"
  }, {
    path: "/contactus.aspx",
    component: _3ad8a987,
    name: "contactUs"
  }, {
    path: "/calculator.aspx",
    component: _6b28b02f,
    name: "calculatorPage"
  }, {
    path: "/cvwizard.aspx",
    component: _1ed2b431,
    name: "cvwizardAbsolute"
  }, {
    path: "/cvwizard/",
    component: _1ed2b431,
    name: "cvwizardFriendly"
  }, {
    path: "/help.aspx",
    component: _f63931a4,
    name: "helpPage"
  }, {
    path: "/",
    component: _2563ddd0,
    alias: ["/csv","/pirsumstat.aspx","/bannerstat.aspx"],
    name: "statisticsRouter"
  }, {
    path: "/ResetPassword.aspx",
    component: _3fb5c5d3,
    name: "ResetPassword"
  }, {
    path: "/smartalertsremove.aspx",
    component: _8236c25c,
    name: "smart-alerts-remove"
  }, {
    path: "/services/previewjob.aspx",
    component: _42a493f0,
    name: "previewJob"
  }, {
    path: "/unsubscribe.aspx",
    component: _7949c117,
    name: "unsubscribePage"
  }, {
    path: "/sendcvsummaryremove.aspx",
    component: _2d9ffad5,
    name: "sendcvsummaryremovePage"
  }, {
    path: "/activatesmartalerts.aspx",
    component: _7ac0cd13,
    name: "activatesmartalertsPage"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
